import { useState } from 'react';
import { Contact } from '@weave/schema-gen-ts/dist/schemas/phone/contacts/contacts/contacts.pb';
import { useTranslation } from '@frontend/i18n';
import { ModalControlResponse, Tabs } from '@frontend/design-system';
import { TrayContainer } from '../../../components/devices/contact-directories/side-modals';
import { CreateNewDirectory } from '../../../components/devices/contact-directories/side-modals/create-new-directory-modal';
import { AllContactsTable } from '../../../components/devices/contact-directories/tables/all-contacts-table';
import { ContactDirectoriesTable } from '../../../components/devices/contact-directories/tables/contact-directories-table';
import { DeviceAssignmentsTable } from '../../../components/devices/contact-directories/tables/device-assignments-table';

export const ContactDirectories = (newContactDirectoryModal: ModalControlResponse) => {
  const { t } = useTranslation('phone', { keyPrefix: 'contact-directories' });
  const [assignedContacts, setAssignedContacts] = useState<Contact[]>([]);

  return (
    <>
      <Tabs initialTab='contact-lists-tab'>
        <Tabs.Bar>
          <Tabs.Tab id='contact-lists-tab'>{t('Contact Lists')}</Tabs.Tab>
          <Tabs.Tab trackingId='NWX-RPB-AllContacts' id='all-contacts-tab'>
            {t('All Contacts')}
          </Tabs.Tab>
          <Tabs.Tab trackingId='NWX-RPB-DeviceAssignments' id='device-assignments-tab'>
            {t('Device Assignments')}
          </Tabs.Tab>
        </Tabs.Bar>
        <Tabs.Panel controller='contact-lists-tab'>
          <ContactDirectoriesTable {...newContactDirectoryModal.triggerProps} />
        </Tabs.Panel>
        <Tabs.Panel controller='all-contacts-tab'>
          <AllContactsTable setAssignedContacts={setAssignedContacts} {...newContactDirectoryModal.triggerProps} />
        </Tabs.Panel>
        <Tabs.Panel controller='device-assignments-tab'>
          <DeviceAssignmentsTable />
        </Tabs.Panel>
      </Tabs>
      <TrayContainer modalProps={newContactDirectoryModal.modalProps}>
        <CreateNewDirectory assignableContacts={assignedContacts} {...newContactDirectoryModal.modalProps} />
      </TrayContainer>
    </>
  );
};
